!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("react"), require("classnames"));else if ("function" == typeof define && define.amd) define(["react", "classnames"], e);else {
    var r = "object" == typeof exports ? e(require("react"), require("classnames")) : e(t.react, t.classnames);
    for (var n in r) ("object" == typeof exports ? exports : t)[n] = r[n];
  }
}("undefined" != typeof self ? self : this, function (t, e) {
  return function (t) {
    var e = {};
    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) r.d(n, o, function (e) {
        return t[e];
      }.bind(null, o));
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 129);
  }({
    0: function _(e, r) {
      e.exports = t;
    },
    1: function _(t, r) {
      t.exports = e;
    },
    129: function _(t, e, r) {
      "use strict";

      var _n,
        o = this && this.__extends || (_n = function n(t, e) {
          return (_n = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
          })(t, e);
        }, function (t, e) {
          function r() {
            this.constructor = t;
          }
          _n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
        }),
        l = this && this.__assign || function () {
          return (l = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            return t;
          }).apply(this, arguments);
        },
        i = this && this.__rest || function (t, e) {
          var r = {};
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
          }
          return r;
        },
        a = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var c = a(r(0)),
        s = a(r(1)),
        u = r(149),
        f = r(130),
        p = r(131),
        h = function h(t) {
          return t.replace(/-(\w)/g, function (t, e) {
            return e.toUpperCase();
          });
        },
        d = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.areaElement = c.default.createRef(), e.contentElement = c.default.createRef(), e.state = {
              classList: new Set(),
              areaClassList: new Set(),
              scrollAreaStyleProperty: {},
              scrollContentStyleProperty: {}
            }, e.setStyleToElement = function (t, r, n) {
              var o,
                l = h(t),
                i = Object.assign({}, e.state[n], ((o = {})[l] = r, o));
              e.setState(function (t) {
                var e;
                return Object.assign(t, ((e = {})[n] = i, e));
              });
            }, e.getBoundingClientRectOf = function (t) {
              if (!t) {
                return {
                  bottom: 0,
                  height: 0,
                  left: 0,
                  right: 0,
                  top: 0,
                  width: 0,
                  x: 0,
                  y: 0
                };
              }
              return t.getBoundingClientRect();
            }, e.getScrollPosition = function () {
              return e.foundation.getScrollPosition();
            }, e.getScrollContentWidth = function () {
              return e.contentElement.current ? e.contentElement.current.offsetWidth : 0;
            }, e.incrementScroll = function (t) {
              e.foundation.incrementScroll(t);
            }, e.scrollTo = function (t) {
              e.foundation.scrollTo(t);
            }, e.handleWheel_ = function (t) {
              e.props.onWheel && e.props.onWheel(t), e.foundation.handleInteraction();
            }, e.handleTouchStart_ = function (t) {
              e.props.onTouchStart && e.props.onTouchStart(t), e.foundation.handleInteraction();
            }, e.handlePointerDown_ = function (t) {
              e.props.onPointerDown && e.props.onPointerDown(t), e.foundation.handleInteraction();
            }, e.handleMouseDown_ = function (t) {
              e.props.onMouseDown && e.props.onMouseDown(t), e.foundation.handleInteraction();
            }, e.handleKeyDown_ = function (t) {
              e.props.onKeyDown && e.props.onKeyDown(t), e.foundation.handleInteraction();
            }, e.handleTransitionEnd_ = function (t) {
              e.props.onTransitionEnd && e.props.onTransitionEnd(t), e.foundation.handleTransitionEnd(t.nativeEvent);
            }, e;
          }
          return o(e, t), e.prototype.componentDidMount = function () {
            this.foundation = new u.MDCTabScrollerFoundation(this.adapter), this.foundation.init();
          }, e.prototype.componentWillUnmount = function () {
            this.foundation.destroy();
          }, Object.defineProperty(e.prototype, "classes", {
            get: function get() {
              var t = this.props,
                e = t.alignStart,
                r = t.alignEnd,
                n = t.alignCenter,
                o = t.className,
                l = this.state.classList;
              return s.default("mdc-tab-scroller", Array.from(l), o, {
                "mdc-tab-scroller--align-start": e,
                "mdc-tab-scroller--align-end": r,
                "mdc-tab-scroller--align-center": n
              });
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "adapter", {
            get: function get() {
              var t = this;
              return {
                eventTargetMatchesSelector: function eventTargetMatchesSelector(t, e) {
                  return !!e && p.matches(t, e);
                },
                addClass: function addClass(e) {
                  var r = new Set(t.state.classList);
                  r.add(e), t.setState({
                    classList: r
                  });
                },
                removeClass: function removeClass(e) {
                  var r = new Set(t.state.classList);
                  r.delete(e), t.setState({
                    classList: r
                  });
                },
                addScrollAreaClass: function addScrollAreaClass(e) {
                  var r = new Set(t.state.areaClassList);
                  r.add(e), t.setState({
                    areaClassList: r
                  });
                },
                setScrollAreaStyleProperty: function setScrollAreaStyleProperty(e, r) {
                  return t.setStyleToElement(e, r, "scrollAreaStyleProperty");
                },
                setScrollContentStyleProperty: function setScrollContentStyleProperty(e, r) {
                  return t.setStyleToElement(e, r, "scrollContentStyleProperty");
                },
                getScrollContentStyleValue: function getScrollContentStyleValue(e) {
                  return t.contentElement.current ? window.getComputedStyle(t.contentElement.current).getPropertyValue(e) : "";
                },
                setScrollAreaScrollLeft: function setScrollAreaScrollLeft(e) {
                  t.areaElement.current && (t.areaElement.current.scrollLeft = e);
                },
                getScrollAreaScrollLeft: function getScrollAreaScrollLeft() {
                  return t.areaElement.current ? t.areaElement.current.scrollLeft : 0;
                },
                getScrollContentOffsetWidth: this.getScrollContentWidth,
                getScrollAreaOffsetWidth: function getScrollAreaOffsetWidth() {
                  return t.areaElement.current ? t.areaElement.current.offsetWidth : 0;
                },
                computeScrollAreaClientRect: function computeScrollAreaClientRect() {
                  return t.getBoundingClientRectOf(t.contentElement.current);
                },
                computeScrollContentClientRect: function computeScrollContentClientRect() {
                  return t.getBoundingClientRectOf(t.contentElement.current);
                },
                computeHorizontalScrollbarHeight: function computeHorizontalScrollbarHeight() {
                  return f.computeHorizontalScrollbarHeight(document);
                }
              };
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.render = function () {
            var t = this.state,
              e = t.areaClassList,
              r = t.scrollAreaStyleProperty,
              n = t.scrollContentStyleProperty,
              o = this.props,
              a = o.children,
              u = (o.alignStart, o.alignEnd, o.alignCenter, o.className, o.onWheel, o.onTouchStart, o.onPointerDown, o.onMouseDown, o.onKeyDown, o.onTransitionEnd, i(o, ["children", "alignStart", "alignEnd", "alignCenter", "className", "onWheel", "onTouchStart", "onPointerDown", "onMouseDown", "onKeyDown", "onTransitionEnd"])),
              f = s.default("mdc-tab-scroller__scroll-area", Array.from(e));
            return c.default.createElement("div", l({
              className: this.classes,
              onWheel: this.handleWheel_,
              onTouchStart: this.handleTouchStart_,
              onPointerDown: this.handlePointerDown_,
              onMouseDown: this.handleMouseDown_,
              onKeyDown: this.handleKeyDown_,
              onTransitionEnd: this.handleTransitionEnd_
            }, u), c.default.createElement("div", {
              className: f,
              style: r,
              ref: this.areaElement
            }, c.default.createElement("div", {
              className: "mdc-tab-scroller__scroll-content",
              style: n,
              ref: this.contentElement
            }, a)));
          }, e.defaultProps = {
            alignStart: !1,
            alignEnd: !1,
            alignCenter: !1,
            className: "",
            children: null,
            onWheel: function onWheel() {},
            onTouchStart: function onTouchStart() {},
            onPointerDown: function onPointerDown() {},
            onMouseDown: function onMouseDown() {},
            onKeyDown: function onKeyDown() {},
            onTransitionEnd: function onTransitionEnd() {}
          }, e;
        }(c.default.Component);
      e.default = d;
    },
    130: function _(t, e, r) {
      "use strict";

      r.r(e), r.d(e, "computeHorizontalScrollbarHeight", function () {
        return l;
      });
      var n,
        o = r(25);
      /**
       * @license
       * Copyright 2018 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      function l(t, e) {
        if (void 0 === e && (e = !0), e && void 0 !== n) return n;
        var r = t.createElement("div");
        r.classList.add(o.a.SCROLL_TEST), t.body.appendChild(r);
        var l = r.offsetHeight - r.clientHeight;
        return t.body.removeChild(r), e && (n = l), l;
      }
    },
    131: function _(t, e, r) {
      "use strict";

      /**
       * @license
       * Copyright 2018 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      function n(t, e) {
        if (t.closest) return t.closest(e);
        for (var r = t; r;) {
          if (o(r, e)) return r;
          r = r.parentElement;
        }
        return null;
      }
      function o(t, e) {
        return (t.matches || t.webkitMatchesSelector || t.msMatchesSelector).call(t, e);
      }
      r.r(e), r.d(e, "closest", function () {
        return n;
      }), r.d(e, "matches", function () {
        return o;
      });
    },
    149: function _(t, e, r) {
      "use strict";

      r.r(e);
      "function" == typeof Symbol && Symbol.iterator;
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */
      var _n2 = function n(t, e) {
        return (_n2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
        })(t, e);
      };
      function o(t, e) {
        function r() {
          this.constructor = t;
        }
        _n2(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }
      var _l = function l() {
        return (_l = Object.assign || function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
          return t;
        }).apply(this, arguments);
      };
      function i(t, e) {
        var r = "function" == typeof Symbol && t[Symbol.iterator];
        if (!r) return t;
        var n,
          o,
          l = r.call(t),
          i = [];
        try {
          for (; (void 0 === e || e-- > 0) && !(n = l.next()).done;) i.push(n.value);
        } catch (t) {
          o = {
            error: t
          };
        } finally {
          try {
            n && !n.done && (r = l.return) && r.call(l);
          } finally {
            if (o) throw o.error;
          }
        }
        return i;
      }
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var a = function () {
          function t(t) {
            void 0 === t && (t = {}), this.adapter_ = t;
          }
          return Object.defineProperty(t, "cssClasses", {
            get: function get() {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "strings", {
            get: function get() {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "numbers", {
            get: function get() {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "defaultAdapter", {
            get: function get() {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.init = function () {}, t.prototype.destroy = function () {}, t;
        }(),
        c = r(25),
        s = function () {
          return function (t) {
            this.adapter_ = t;
          };
        }(),
        u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.getScrollPositionRTL = function () {
            var t = this.adapter_.getScrollAreaScrollLeft(),
              e = this.calculateScrollEdges_().right;
            return Math.round(e - t);
          }, e.prototype.scrollToRTL = function (t) {
            var e = this.calculateScrollEdges_(),
              r = this.adapter_.getScrollAreaScrollLeft(),
              n = this.clampScrollValue_(e.right - t);
            return {
              finalScrollPosition: n,
              scrollDelta: n - r
            };
          }, e.prototype.incrementScrollRTL = function (t) {
            var e = this.adapter_.getScrollAreaScrollLeft(),
              r = this.clampScrollValue_(e - t);
            return {
              finalScrollPosition: r,
              scrollDelta: r - e
            };
          }, e.prototype.getAnimatingScrollPosition = function (t) {
            return t;
          }, e.prototype.calculateScrollEdges_ = function () {
            return {
              left: 0,
              right: this.adapter_.getScrollContentOffsetWidth() - this.adapter_.getScrollAreaOffsetWidth()
            };
          }, e.prototype.clampScrollValue_ = function (t) {
            var e = this.calculateScrollEdges_();
            return Math.min(Math.max(e.left, t), e.right);
          }, e;
        }(s),
        f = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.getScrollPositionRTL = function (t) {
            var e = this.adapter_.getScrollAreaScrollLeft();
            return Math.round(t - e);
          }, e.prototype.scrollToRTL = function (t) {
            var e = this.adapter_.getScrollAreaScrollLeft(),
              r = this.clampScrollValue_(-t);
            return {
              finalScrollPosition: r,
              scrollDelta: r - e
            };
          }, e.prototype.incrementScrollRTL = function (t) {
            var e = this.adapter_.getScrollAreaScrollLeft(),
              r = this.clampScrollValue_(e - t);
            return {
              finalScrollPosition: r,
              scrollDelta: r - e
            };
          }, e.prototype.getAnimatingScrollPosition = function (t, e) {
            return t - e;
          }, e.prototype.calculateScrollEdges_ = function () {
            var t = this.adapter_.getScrollContentOffsetWidth();
            return {
              left: this.adapter_.getScrollAreaOffsetWidth() - t,
              right: 0
            };
          }, e.prototype.clampScrollValue_ = function (t) {
            var e = this.calculateScrollEdges_();
            return Math.max(Math.min(e.right, t), e.left);
          }, e;
        }(s),
        p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.getScrollPositionRTL = function (t) {
            var e = this.adapter_.getScrollAreaScrollLeft();
            return Math.round(e - t);
          }, e.prototype.scrollToRTL = function (t) {
            var e = this.adapter_.getScrollAreaScrollLeft(),
              r = this.clampScrollValue_(t);
            return {
              finalScrollPosition: r,
              scrollDelta: e - r
            };
          }, e.prototype.incrementScrollRTL = function (t) {
            var e = this.adapter_.getScrollAreaScrollLeft(),
              r = this.clampScrollValue_(e + t);
            return {
              finalScrollPosition: r,
              scrollDelta: e - r
            };
          }, e.prototype.getAnimatingScrollPosition = function (t, e) {
            return t + e;
          }, e.prototype.calculateScrollEdges_ = function () {
            return {
              left: this.adapter_.getScrollContentOffsetWidth() - this.adapter_.getScrollAreaOffsetWidth(),
              right: 0
            };
          }, e.prototype.clampScrollValue_ = function (t) {
            var e = this.calculateScrollEdges_();
            return Math.min(Math.max(e.right, t), e.left);
          }, e;
        }(s);
      r.d(e, "MDCTabScrollerFoundation", function () {
        return h;
      });
      /**
       * @license
       * Copyright 2018 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var h = function (t) {
        function e(r) {
          var n = t.call(this, _l({}, e.defaultAdapter, r)) || this;
          return n.isAnimating_ = !1, n;
        }
        return o(e, t), Object.defineProperty(e, "cssClasses", {
          get: function get() {
            return c.a;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "strings", {
          get: function get() {
            return c.b;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "defaultAdapter", {
          get: function get() {
            return {
              eventTargetMatchesSelector: function eventTargetMatchesSelector() {
                return !1;
              },
              addClass: function addClass() {},
              removeClass: function removeClass() {},
              addScrollAreaClass: function addScrollAreaClass() {},
              setScrollAreaStyleProperty: function setScrollAreaStyleProperty() {},
              setScrollContentStyleProperty: function setScrollContentStyleProperty() {},
              getScrollContentStyleValue: function getScrollContentStyleValue() {
                return "";
              },
              setScrollAreaScrollLeft: function setScrollAreaScrollLeft() {},
              getScrollAreaScrollLeft: function getScrollAreaScrollLeft() {
                return 0;
              },
              getScrollContentOffsetWidth: function getScrollContentOffsetWidth() {
                return 0;
              },
              getScrollAreaOffsetWidth: function getScrollAreaOffsetWidth() {
                return 0;
              },
              computeScrollAreaClientRect: function computeScrollAreaClientRect() {
                return {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  width: 0,
                  height: 0
                };
              },
              computeScrollContentClientRect: function computeScrollContentClientRect() {
                return {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  width: 0,
                  height: 0
                };
              },
              computeHorizontalScrollbarHeight: function computeHorizontalScrollbarHeight() {
                return 0;
              }
            };
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.init = function () {
          var t = this.adapter_.computeHorizontalScrollbarHeight();
          this.adapter_.setScrollAreaStyleProperty("margin-bottom", -t + "px"), this.adapter_.addScrollAreaClass(e.cssClasses.SCROLL_AREA_SCROLL);
        }, e.prototype.getScrollPosition = function () {
          if (this.isRTL_()) return this.computeCurrentScrollPositionRTL_();
          var t = this.calculateCurrentTranslateX_();
          return this.adapter_.getScrollAreaScrollLeft() - t;
        }, e.prototype.handleInteraction = function () {
          this.isAnimating_ && this.stopScrollAnimation_();
        }, e.prototype.handleTransitionEnd = function (t) {
          var r = t.target;
          this.isAnimating_ && this.adapter_.eventTargetMatchesSelector(r, e.strings.CONTENT_SELECTOR) && (this.isAnimating_ = !1, this.adapter_.removeClass(e.cssClasses.ANIMATING));
        }, e.prototype.incrementScroll = function (t) {
          if (0 !== t) return this.isRTL_() ? this.incrementScrollRTL_(t) : void this.incrementScroll_(t);
        }, e.prototype.scrollTo = function (t) {
          if (this.isRTL_()) return this.scrollToRTL_(t);
          this.scrollTo_(t);
        }, e.prototype.getRTLScroller = function () {
          return this.rtlScrollerInstance_ || (this.rtlScrollerInstance_ = this.rtlScrollerFactory_()), this.rtlScrollerInstance_;
        }, e.prototype.calculateCurrentTranslateX_ = function () {
          var t = this.adapter_.getScrollContentStyleValue("transform");
          if ("none" === t) return 0;
          var e = /\((.+?)\)/.exec(t);
          if (!e) return 0;
          var r = i(e[1].split(","), 6),
            n = (r[0], r[1], r[2], r[3], r[4]);
          r[5];
          return parseFloat(n);
        }, e.prototype.clampScrollValue_ = function (t) {
          var e = this.calculateScrollEdges_();
          return Math.min(Math.max(e.left, t), e.right);
        }, e.prototype.computeCurrentScrollPositionRTL_ = function () {
          var t = this.calculateCurrentTranslateX_();
          return this.getRTLScroller().getScrollPositionRTL(t);
        }, e.prototype.calculateScrollEdges_ = function () {
          return {
            left: 0,
            right: this.adapter_.getScrollContentOffsetWidth() - this.adapter_.getScrollAreaOffsetWidth()
          };
        }, e.prototype.scrollTo_ = function (t) {
          var e = this.getScrollPosition(),
            r = this.clampScrollValue_(t),
            n = r - e;
          this.animate_({
            finalScrollPosition: r,
            scrollDelta: n
          });
        }, e.prototype.scrollToRTL_ = function (t) {
          var e = this.getRTLScroller().scrollToRTL(t);
          this.animate_(e);
        }, e.prototype.incrementScroll_ = function (t) {
          var e = this.getScrollPosition(),
            r = t + e,
            n = this.clampScrollValue_(r),
            o = n - e;
          this.animate_({
            finalScrollPosition: n,
            scrollDelta: o
          });
        }, e.prototype.incrementScrollRTL_ = function (t) {
          var e = this.getRTLScroller().incrementScrollRTL(t);
          this.animate_(e);
        }, e.prototype.animate_ = function (t) {
          var r = this;
          0 !== t.scrollDelta && (this.stopScrollAnimation_(), this.adapter_.setScrollAreaScrollLeft(t.finalScrollPosition), this.adapter_.setScrollContentStyleProperty("transform", "translateX(" + t.scrollDelta + "px)"), this.adapter_.computeScrollAreaClientRect(), requestAnimationFrame(function () {
            r.adapter_.addClass(e.cssClasses.ANIMATING), r.adapter_.setScrollContentStyleProperty("transform", "none");
          }), this.isAnimating_ = !0);
        }, e.prototype.stopScrollAnimation_ = function () {
          this.isAnimating_ = !1;
          var t = this.getAnimatingScrollPosition_();
          this.adapter_.removeClass(e.cssClasses.ANIMATING), this.adapter_.setScrollContentStyleProperty("transform", "translateX(0px)"), this.adapter_.setScrollAreaScrollLeft(t);
        }, e.prototype.getAnimatingScrollPosition_ = function () {
          var t = this.calculateCurrentTranslateX_(),
            e = this.adapter_.getScrollAreaScrollLeft();
          return this.isRTL_() ? this.getRTLScroller().getAnimatingScrollPosition(e, t) : e - t;
        }, e.prototype.rtlScrollerFactory_ = function () {
          var t = this.adapter_.getScrollAreaScrollLeft();
          this.adapter_.setScrollAreaScrollLeft(t - 1);
          var e = this.adapter_.getScrollAreaScrollLeft();
          if (e < 0) return this.adapter_.setScrollAreaScrollLeft(t), new f(this.adapter_);
          var r = this.adapter_.computeScrollAreaClientRect(),
            n = this.adapter_.computeScrollContentClientRect(),
            o = Math.round(n.right - r.right);
          return this.adapter_.setScrollAreaScrollLeft(t), o === e ? new p(this.adapter_) : new u(this.adapter_);
        }, e.prototype.isRTL_ = function () {
          return "rtl" === this.adapter_.getScrollContentStyleValue("direction");
        }, e;
      }(a);
      e.default = h;
    },
    25: function _(t, e, r) {
      "use strict";

      r.d(e, "a", function () {
        return n;
      }), r.d(e, "b", function () {
        return o;
      });
      /**
       * @license
       * Copyright 2018 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var n = {
          ANIMATING: "mdc-tab-scroller--animating",
          SCROLL_AREA_SCROLL: "mdc-tab-scroller__scroll-area--scroll",
          SCROLL_TEST: "mdc-tab-scroller__test"
        },
        o = {
          AREA_SELECTOR: ".mdc-tab-scroller__scroll-area",
          CONTENT_SELECTOR: ".mdc-tab-scroller__scroll-content"
        };
    }
  });
});